let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gv9yB")).then(() => parcelRequire('7dsYV'));